import React, { useContext, useEffect, useRef, useState } from "react";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import { Video } from "../Video";
import style from "./VideoSlider.module.scss";
import cx from "classnames";
import useDrag from "../../Slider/useDrag";
import { SliderDraggingContext } from "../../Slider/Slider";
import YouTube from "react-youtube";
import { sendGtag } from "../../../utils";
type ScrollVisibilityApiType = React.ContextType<typeof VisibilityContext>;

function LeftArrow() {
  const { isFirstItemVisible, scrollPrev } =
    React.useContext(VisibilityContext);

  return (
    <Arrow disabled={isFirstItemVisible} onClick={() => scrollPrev()}>
      <svg
        width="57"
        height="17"
        viewBox="0 0 57 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.29456 6.07226L54.2406 6.08288C55.4172 6.08288 56.3711 7.03542 56.3711 8.22889C56.3711 9.4141 55.4163 10.3749 54.2406 10.3749L7.28765 10.3643L9.69756 12.7881C10.5231 13.6185 10.5227 14.9651 9.68364 15.809C8.85039 16.6471 7.4945 16.6422 6.68008 15.823L0.617291 9.72521C0.206788 9.31234 0.000505816 8.7718 9.78867e-08 8.22889L0.0063699 8.21251C0.00752589 7.6675 0.212341 7.12557 0.617291 6.71828L6.68008 0.620451C7.50565 -0.20989 8.84458 -0.209469 9.68364 0.634445C10.5169 1.47252 10.512 2.83624 9.69756 3.65537L7.29456 6.07226Z"
          fill="#D32D32"
        />
      </svg>
    </Arrow>
  );
}

function RightArrow() {
  const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext);

  return (
    <Arrow disabled={isLastItemVisible} onClick={() => scrollNext()}>
      <svg
        width="57"
        height="17"
        viewBox="0 0 57 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M49.0765 10.3652L2.13049 10.3546C0.953849 10.3546 -4.10978e-07 9.40208 -3.5881e-07 8.20861C-3.07002e-07 7.0234 0.954799 6.06259 2.13049 6.06259L49.0834 6.07322L46.6735 3.64938C45.848 2.81904 45.8484 1.47236 46.6875 0.62845C47.5207 -0.20962 48.8766 -0.204671 49.691 0.614458L55.7538 6.71229C56.1643 7.12516 56.3706 7.6657 56.3711 8.20861L56.3647 8.22499C56.3636 8.77 56.1588 9.31193 55.7538 9.71922L49.691 15.817C48.8654 16.6474 47.5265 16.647 46.6874 15.8031C45.8542 14.965 45.8591 13.6013 46.6735 12.7821L49.0765 10.3652Z"
          fill="#D32D32"
        />
      </svg>
    </Arrow>
  );
}

const Arrow = ({
  children,
  disabled,
  onClick,
}: {
  children: React.ReactNode;
  disabled: boolean;
  onClick: VoidFunction;
}) => {
  return (
    <button
      className={style.arrow}
      disabled={disabled}
      onClick={onClick}
      style={{
        cursor: "pointer",
        flexDirection: "column",
        justifyContent: "center",

        opacity: disabled ? "0" : "1",
        userSelect: "none",
      }}
    >
      {children}
    </button>
  );
};

const Card = ({ itemId, youtube, label }: { itemId: string; youtube: string, label: string }) => {
  const visibility = React.useContext(VisibilityContext);
  const { dragging, dragStop } = useContext(SliderDraggingContext);
  const [clickable, setClickable] = useState(false);
  const isVisible = visibility.isItemVisible(itemId);
  const ref = useRef<YouTube | null>(null)
  if(!isVisible && clickable){
    setClickable(false)
    ref.current?.getInternalPlayer().pauseVideo()
  }
  const data = {
    'data-category': 'internal',
    'data-action': 'click',
    'data-label': label
  }
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
      }}
      
      onClick={(e) => {
        if (dragging) {
          e.stopPropagation();
          e.preventDefault();
        }
      }}
    >
      {!clickable && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: 'center',
            alignItems: 'center'
          }}
          {...data}
          onClick={() => {
            if(!dragging){
              setClickable(true)
              sendGtag(data["data-category"], data["data-action"], data["data-label"] )
              ref.current?.getInternalPlayer().playVideo()
            }
          }}
        >
          <div><img src="/images/play.svg" alt="" /></div>
        </div>
      )}
      <YouTube
        ref={ref}
        videoId={youtube.split("/").reverse()[0]}
        onPause={() => {
          setClickable(false)
        }}
        className={cx(style.iframe, { [style["iframe-noclick"]]: dragging })}
        containerClassName={style.iframe}
      />
      {/* <Video youtube={youtube} />; */}
    </div>
  );
};

export const VideoSlider = (props: { video: {label: string, link: string}[] }) => {
  const [visibleItem, setVisibleItem] = useState("0");
  const { dragStart, dragStop, dragMove, dragging } = useDrag();
  const handleDrag =
    ({ scrollContainer }: ScrollVisibilityApiType) =>
    (ev: React.MouseEvent) =>
      dragMove(ev, (posDiff) => {
        if (scrollContainer.current) {
          scrollContainer.current.scrollLeft += posDiff;
        }
      });
  return (
    <div className={style["video-block"]}>
      <SliderDraggingContext.Provider value={{ dragStop, dragging }}>
        <ScrollMenu
          LeftArrow={LeftArrow}
          RightArrow={RightArrow}
          onMouseDown={() => dragStart}
          onMouseUp={() => dragStop}
          onMouseMove={handleDrag}
          onUpdate={(apiRef) => {
            const visibleArr = apiRef.items
              .getVisible()
              .filter((item) => !item[0].includes("separator"));
            if (visibleArr.length > 0) {
              setVisibleItem(visibleArr[0][0]);
            }
          }}
        >
          {props.video.map((video, i) => {
            return (
              <Card
                itemId={`${i}`} // NOTE: itemId is required for track items
                key={i}
                youtube={video.link}
                label={video.label}
              />
            );
          })}
        </ScrollMenu>
      </SliderDraggingContext.Provider>
      <div className={style.dots}>
        {props.video.map((_, i) => {
          return <Dot isHighlighted={`${i}` == visibleItem} />;
        })}
      </div>
    </div>
  );
};

const Dot = ({ isHighlighted }: { isHighlighted: boolean }) => {
  return (
    <div
      className={cx(style.dot, {
        [style["active-dot"]]: isHighlighted,
      })}
    />
  );
};
